import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear storeId and accessToken from localStorage
    localStorage.removeItem("storeId");
    localStorage.removeItem("accessToken");

    // Redirect to the login page
    navigate("/");
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "#424242" }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, color: "#fff" }}>
          Uber Eats Admin Dashboard
        </Typography>
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleLogout}
          sx={{
            borderColor: "#fff",
            color: "#fff",
            ":hover": {
              backgroundColor: "#616161",
              borderColor: "#e0e0e0",
            },
          }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
